import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Специальные предложения по маркам',
  banner: {
    title: 'Сниженные лизинговые платежи на автомобили премиум-класса',
  },
  leaveRequest: 'Подать заявку',
  price: {
    mercedes: 'от 34 000 ₽',
    toyota: 'от 22 000 ₽',
    landRover: 'от 20 000 ₽',
    bmw: 'от 37 000 ₽',
    volkswagen: 'от 25 000 ₽',
    audi: 'от 43 000 ₽',
    kamaz: 'от 73 000 ₽',
    lada: 'от 10 000 ₽',
  },
  perMonth: 'в месяц',
} satisfies TMessages
